import { render, staticRenderFns } from "./GroupPlansModalContent.vue?vue&type=template&id=49e6e382&scoped=true&"
import script from "./GroupPlansModalContent.vue?vue&type=script&lang=ts&"
export * from "./GroupPlansModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./GroupPlansModalContent.vue?vue&type=style&index=0&id=49e6e382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6e382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49e6e382', component.options)
    } else {
      api.reload('49e6e382', component.options)
    }
    module.hot.accept("./GroupPlansModalContent.vue?vue&type=template&id=49e6e382&scoped=true&", function () {
      api.rerender('49e6e382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/group-plans/GroupPlansModalContent.vue"
export default component.exports